import { Box } from '@bonanza-social/moonlight';
import TimerSection from './TimerSection/TimerSection';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectRegistrationConfig } from '../../../state/registrationConfig/registrationConfig.slice';
import ProgressSection from './ProgressSection/ProgressSection';

function ClaimStatusBar() {
  const config = useSelector(selectRegistrationConfig);
  const hideProgressBar = config?.hideProgressBar;
  return (
    <Box
      paddingBottom="space-100"
      flexDirection="row"
      justifyContent={!hideProgressBar ? 'space-between' : 'center'}
    >
      <TimerSection />
      {!hideProgressBar ? <ProgressSection /> : null}
    </Box>
  );
}

export default ClaimStatusBar;
